import { Post } from '@wellesley/openapi'
import { type Action } from 'components/ActionsDropdown'
import { Heart, History } from 'lucide-react'
import { useAppsNavigate } from '@wellesley/router'
import { useLoginGuardAction } from '@wellesley/auth'
import { getPostEditsRoute, getPostActivityRoute } from 'helpers/routes'

type Props = {
  feed: Post
}

const useHistoryActions = ({ feed }: Props) => {
  const navigate = useAppsNavigate()
  const guardedAction = useLoginGuardAction()

  const isEdited = feed.edited
  const hideActivityButton =
    !feed.stats.likes && !feed.stats.reposts && !feed.stats.quotes

  const actions: Action[] = [
    {
      icon: <History size={20} color="var(--gray-900)" />,
      name: 'Edits history',
      isHidden: !isEdited,
      handler: guardedAction(() => {
        navigate(getPostEditsRoute(feed.author, feed.id))
      }),
    },
    {
      icon: <Heart size={20} color="var(--gray-900)" />,
      name: 'Activity history',
      isHidden: hideActivityButton,
      handler: guardedAction(() => {
        navigate(getPostActivityRoute(feed.author, feed.id))
      }),
    },
  ]

  return [actions] as const
}

export default useHistoryActions
